import { useEffect } from "react"

import { Col, Row } from "react-bootstrap"

import NotificationApplicationUsersGridRow from "./NotificationApplicationUsersGridRow"
import NotificationApplicationUserData from "../../../api/Randoms/Notification/NotificationApplicationUserData"
import useNotificationApplicationUsersLoad from "../../../api/Randoms/Notification/useNotificationApplicationUsersLoad"
import LoadingTableBodyWrapper from "../../LoadingTableBodyWrapper"
import LoadingTableWrapper from "../../LoadingTableWrapper"
import SearchBar from "../../SearchBar"
import TablePagination from "../../TablePagination"

interface NotificationApplicationUsersGridProps {
  poolId: number
  onSelectUser: (user: NotificationApplicationUserData | null) => void
}

function NotificationApplicationUsersGrid({ poolId, onSelectUser }: NotificationApplicationUsersGridProps) {
  const DEFAULT_SEARCH_FIELDS = [
    { ID: "All", Name: "All" },
    { ID: "UserName", Name: "User Name" },
    { ID: "FirstName", Name: "First Name" },
    { ID: "LastName", Name: "Last Name" },
    { ID: "Email", Name: "Email" },
    { ID: "Phone", Name: "Phone Number" },
  ]

  const {
    gridData,
    loadingApplicationUsers,
    pageNumber,
    setPage,
    searchApplicationUsers,
    selectOneApplicationUser,
    selectedApplicationUsers,
  } = useNotificationApplicationUsersLoad(poolId)

  useEffect(() => {
    onSelectUser(selectedApplicationUsers[0] || null)
  }, [selectedApplicationUsers, onSelectUser])

  return (
    <>
      <SearchBar
        defaultField={DEFAULT_SEARCH_FIELDS[0]}
        resetButton
        variant="full-width"
        onSearch={searchApplicationUsers}
        searchFields={DEFAULT_SEARCH_FIELDS}
        loading={loadingApplicationUsers}
      />
      <LoadingTableWrapper loading={loadingApplicationUsers} variant="light" withHeader>
        <table className="table table-bordered table-responsive mt-2">
          <thead className="thead-light text-nowrap text-uppercase">
            <tr>
              <th className="text-center col-auto px-0">&nbsp;</th>
              <th>User Name</th>
              <th>Name</th>
              <th className="col-2">Email address</th>
              <th className="col-1">Phone number</th>
            </tr>
          </thead>
          <tbody className="bg-light">
            <LoadingTableBodyWrapper
              loading={loadingApplicationUsers}
              recordsCount={gridData?.Records?.length || 0}
              columnsCount={5}
              noDataText="No available users found"
            >
              {gridData?.Records?.map((record) => (
                <NotificationApplicationUsersGridRow
                  key={`au_${record.ApplicationUserID}_${record.RoleID}`}
                  user={record}
                  selectUser={selectOneApplicationUser}
                />
              ))}
            </LoadingTableBodyWrapper>
          </tbody>
        </table>
      </LoadingTableWrapper>
      {gridData?.Total > 0 && (
        <Row>
          <Col sm={2}>Total records: {gridData.Total}</Col>
          <Col>
            <TablePagination pageNumber={pageNumber} pages={gridData.Pages || 0} onChange={setPage} className="mb-0" />
          </Col>
        </Row>
      )}
    </>
  )
}

export default NotificationApplicationUsersGrid
